import type { ShipTypeDef } from '../config/ShipTypes';

const FLOATS_PER_MAT = 16;

/**
 * Writes a 4×4 model matrix for a ship into the output buffer.
 * Computes yaw from direction + def offset, applies roll from turn rate.
 */
export function writeShipMatrix(
  out: Float32Array, idx: number, x: number, y: number, z: number,
  dirX: number, dirZ: number, def: ShipTypeDef, turnRate: number,
): void {
  const yaw = Math.atan2(-dirX, -dirZ) + def.yawOffset;
  const cosY = Math.cos(yaw), sinY = Math.sin(yaw);
  const roll = Math.max(-0.45, Math.min(0.45, -turnRate * 3.0));
  const cr = Math.cos(roll), sr = Math.sin(roll);
  const sc = def.scale;
  const o = idx * FLOATS_PER_MAT;
  out[o]    = cosY*sc;  out[o+4]  = sinY*sr*sc; out[o+8]  = sinY*cr*sc; out[o+12] = x;
  out[o+1]  = 0;        out[o+5]  = cr*sc;      out[o+9]  = -sr*sc;     out[o+13] = y;
  out[o+2]  = -sinY*sc; out[o+6]  = cosY*sr*sc; out[o+10] = cosY*cr*sc; out[o+14] = z;
  out[o+3]  = 0;        out[o+7]  = 0;          out[o+11] = 0;          out[o+15] = 1;
}
